module.exports = __webpack_public_path__ + "media/images/front/products/second_rate/product_2-4f92ee8e622dabf4d1c63696c4e50436.jpg";